import { render, staticRenderFns } from "./ReservationPayments.vue?vue&type=template&id=0c838d6c"
import script from "./ReservationPayments.vue?vue&type=script&lang=js"
export * from "./ReservationPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports